import { Component, OnInit } from "@angular/core";

import { ZonesService } from "../../../core/api/services/zones.service";
import { BaseSelectSearch } from "./base/base-select-search.component";
import { BaseSelectSearchModule } from "./base/base-select.search.module";

@Component({
    selector: "regions-select-search",
    templateUrl: "./base/base-select-search-template.html",
    imports: [BaseSelectSearchModule]
})
export class RegionsSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  constructor(protected currentService: ZonesService) {
    super();
  }

  getItemsApi() {
    if (!this.id) {
      this.initLoading = false;
      this.isFetchData = true;
      return;
    }

    //country
    if (this.id === "null") this.id = null;

    this.currentService
      .zonesGetZonesByParentIdList({ ParentId: this.id })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }
}
